import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/login/LandingPage";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/login/LoginPage";
import RegisterPage from "./pages/login/RegisterPage";
import Main from "./pages/Main";
import { useSelector } from "react-redux";
import App from "./App";
import Welcome from "./Welcome";
import AdminApp from "./AdminApp";
import SamplePage from "./pages/sample/SamplePage";

const Router = () => {

  // const auth = useSelector((state:any)=> state.userInfo.data) // store에서 값을 가져오는 함수
  const auth = useSelector((state:any)=> state.userInfo.data) // store에서 값을 가져오는 함수
  // console.log('Router' , auth)
  // console.log('관리자??',auth.user.roles.some((obj:any) => obj.role === 'ADMIN'), auth.user.roles.filter((obj:any) => obj.role === 'ADMIN'))
  // const filteredArray = auth.user.roles.filter((obj:any) => obj.role === 'ADMIN' && obj.use_yn === 'sample_reject');
  // auth.user.roles.includes("ADMIN")

  // let route_page = auth.user.roles.some((obj:any) => obj.role === 'ADMIN');

  let route_page = auth.user.roles.some((obj:any) => ['ADMIN','MANAGER','WORKER_DIALOG','WORKER_SOUND','WORKER_NOISE'].includes(obj.role));

  let adminRole = auth.user.roles.some((obj:any) => ['ADMIN'].includes(obj.role));

  console.log('워커 권한 상태',adminRole,route_page)


  return (
      <Routes>
        {route_page ? 
        <React.Fragment>
          <Route path="/admin/*" element={<AdminApp adminRole={adminRole} />} />
          <Route path="/*" element={<App />} />
          <Route path="*" element={<NotFound />} />
        </React.Fragment>
        :
        <React.Fragment>
          {/* <Route path="/" element={<LandingPage />} /> */}
          
          <Route path="/welcome" element={<Welcome />} />
          {/* <Route path="/login" element={<LoginPage />} /> */}
          
          <Route path="/register" element={<RegisterPage />} />
          {auth.login && <Route path="/insight/*" element={<Main />} />}
          {/* <Route path="/insight/*" element={<Main />} /> */}
          <Route path="/*" element={<App />} />
          <Route path="*" element={<NotFound />} />
        </React.Fragment>
        }
        
      </Routes>
    
  );
};

export default Router;
